import { Box, Button, Grid, Modal, Tab, Tabs } from "@mui/material";
import {
  RHFCheckbox,
  RHFDateTimePicker,
  RHFTextField,
} from "../../../../../RHFComponents/RHFComponents";
import { UseFormReturn } from "react-hook-form";
import { AllertMessage } from "../Agenda/MedintAgendaForm/MedintAgendaFormDetail";
import { useEffect } from "react";
import dayjs from "dayjs";

const SospensioneModal = (props: {
  methods: UseFormReturn<any, undefined>;
  showModale: boolean;
  setShowModale: (value: boolean) => void;
  submitFunction: () => Promise<void>;
  sospesaFound: boolean
}) => {

    useEffect(() => {
    if (!props.sospesaFound) {
      props.methods.reset({
        sospesa: false,
        dataSospensione: dayjs(),
        note: "",
      });
    }
  }, []);
  
  return (
    <>
      <Modal open={props.showModale}>
        <Box
          sx={{
            maxHeight: "90vh",
            maxWidth: "60vh",
            width: "50%",
            overflow: "auto",
            paddingTop: 2,
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Tabs value={0} sx={{ paddingLeft: 2, mb: 2 }}>
            <Tab
              sx={{
                fontFamily: "Montserrat",
                fontWeight: "bold",
                textTransform: "none",
              }}
              label="Dati Sospensione"
            />
          </Tabs>
          <Grid
            container
            spacing={2}
            pl={2}
            pb={2}
            pr={2}
            justifyContent="center"
          >
            <Grid item xs={12}>
              <RHFCheckbox
                name="sospesa"
                label="Sospesa"
                control={props.methods.control}
              />
            </Grid>
            <Grid item xs={12}>
              <RHFDateTimePicker
                dateOnly
                name={`dataSospensione`}
                control={props.methods.control}
                size="small"
                fullWidth
                label="Data Sospensione"
                displayFormat="DD/MM/YY"
                valueFormat="YYYY-MM-DD"
                serialize="dayjs"
              />
            </Grid>
            <Grid item xs={12}>
              <RHFTextField
                control={props.methods.control}
                name="note"
                label="Note"
                placeholder="Note eventuali"
                fullWidth
                multiline
                rows={3}
                inputProps={{ maxLength: 400 }}
                helperText={(props.methods.watch("note")?.length ?? 0) + "/400"}
              />
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between">
                <Button
                  variant="outlinedError"
                  onClick={() => props.setShowModale(false)}
                >
                  Uscita
                </Button>

                <Button
                  type="submit"
                  variant="contained"
                  onClick={
                    // props.methods.handleSubmit(async () => {
                    //   await props.submitFunction();
                    // })
                    // FUNZIONA
                    props.methods.handleSubmit(() => props.submitFunction())
                  }
                >
                  Conferma
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default SospensioneModal;
